export default __webpack_public_path__ + "static/media/dimos-lamieon-logo-e1611908863148-removebg-preview.370b1c6f.png";